import { Component } from 'react'
import s from './GlobalSearch.scss'
import { FaUsers, FaSearch, FaInfoCircle } from 'react-icons/fa'
import { Container, Row, Col, UncontrolledTooltip } from 'reactstrap'
import { Checkbox, InputContainer } from 'components/ideal-core-ui'
import { makeGetRequest } from 'utils/api'
import { groupBy } from 'utils/helpers'
import { typeMapper, urlMapper } from './helpers'
import { Link } from 'react-router-dom'
import parse from 'autosuggest-highlight/parse'
import match from 'autosuggest-highlight/match'
import queryString from 'query-string'
import { withRouter } from 'hocs'
import { PageTitle } from 'components/common/PageTitle'

@withRouter
class GlobalSearch extends Component {
  state = {
    deal: true,
    proposal: true,
    contact: true,
    company: true,
    fetching: 0,
    results: [],
    value: ''
  }

  componentDidMount() {
    const { query } = queryString.parse(this.props.router.location.search)
    if (query?.length) {
      this.setState({
        value: query
      })
      this.doSearch(query)
    }
  }

  doSearch = value => {
    const { fetching } = this.state
    if (fetching) clearTimeout(fetching)
    const query = value.trim()

    this.setState({
      value,
      fetching: setTimeout(async () => {
        if (query) {
          if (query.length > 1) {
            const response = await makeGetRequest(
              `/v1/search/?query=${encodeURIComponent(query)}`
            )
            const results = groupBy(response, 'type')
            const values = Object.keys(results)
              .map(section => {
                return {
                  title: section,
                  results: results[section].map(result => ({
                    id: result.id,
                    name: result.title,
                    type: result.type
                  }))
                }
              })
              .filter(section => section.results.length > 0)

            this.setState({
              results: values
            })
          }
        } else {
          this.setState({
            results: []
          })
        }
      }, 300)
    })
  }

  renderSuggestion = (suggestion, query) => {
    const matches = match(suggestion.name, query)
    const parts = parse(suggestion.name, matches)

    return (
      <Link
        key={suggestion.id}
        className={s.resultsItem}
        to={`${urlMapper[suggestion.type]}${suggestion.id}`}
      >
        {parts.map((part, index) => {
          const className = part.highlight ? s.highlight : null

          return (
            <span className={className} key={index}>
              {part.text}
            </span>
          )
        })}
      </Link>
    )
  }

  render() {
    return (
      <>
        <PageTitle view="Search" />
        <Container className={s.container}>
          <Row>
            <Col xl="3">
              <div className={s.filtersWrapper}>
                <div className={s.sidebarTitle}>
                  <FaUsers className={s.faIcon} />
                  Categories and Filters
                </div>
                <div className={s.content}>
                  <div className={s.filters}>
                    <div>
                      <Checkbox
                        isChecked={this.state.deal}
                        triggerCheckbox={() => {
                          this.setState(prevState => ({
                            deal: !prevState.deal
                          }))
                        }}
                      />
                      <span>Opportunities</span>
                    </div>
                    <div>
                      <Checkbox
                        isChecked={this.state.proposal}
                        triggerCheckbox={() => {
                          this.setState(prevState => ({
                            proposal: !prevState.proposal
                          }))
                        }}
                      />
                      <span>Proposals</span>
                    </div>
                    <div>
                      <Checkbox
                        isChecked={this.state.contact}
                        triggerCheckbox={() => {
                          this.setState(prevState => ({
                            contact: !prevState.contact
                          }))
                        }}
                      />
                      <span>Contacts</span>
                    </div>
                    <div>
                      <Checkbox
                        isChecked={this.state.company}
                        triggerCheckbox={() => {
                          this.setState(prevState => ({
                            company: !prevState.company
                          }))
                        }}
                      />
                      <span>Companies</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col xl="9">
              <div className={s.title}>
                Global Search Results (Case Sensitive for Quote and Project Number)
              </div>
              <div className={s.searchWrapper}>
                <FaSearch className={s.searchIcon} />
                <InputContainer
                  type="text"
                  className={s.nameInput}
                  placeholder="Search"
                  value={this.state.value}
                  text={this.state.value}
                  cb={value => this.doSearch(value)}
                />
                <FaInfoCircle id="search" className={s.searchTooltip} />
                <UncontrolledTooltip placement="top" target="search">
                  Type q: to search for a quote number, and p: to search for a project number.
                </UncontrolledTooltip>
              </div>
              <div className={s.results}>
                {!this.state.results.length ? (
                  <p className={s.noResults}>
                    Start your search by typing in the search box above.
                  </p>
                ) : (
                  <div className={s.resultsWrapper}>
                    {this.state.results.map(section => {
                      if (this.state[section.title.toLowerCase()]) {
                        return (
                          <div className={s.itemWrapper} key={section.title}>
                            <p className={s.item}>
                              Results in{' '}
                              {section.title === 'PROPOSAL' ? (
                                <span>{typeMapper[section.title]}</span>
                              ) : (
                                <Link to={urlMapper[section.title]}>
                                  {typeMapper[section.title]}
                                </Link>
                              )}
                            </p>
                            {section.results.map(result =>
                              this.renderSuggestion(result, this.state.value)
                            )}
                          </div>
                        )
                      }
                      return null
                    })}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

export default GlobalSearch
